import { formatDate } from '../../../formatters/formatDate';
import type { SxProps, Theme } from '@mui/material/styles';

export const cellSpacingSx: SxProps<Theme> = { width: '100%' };
export const linkTruncateSx: SxProps<Theme> = {
  display: 'inline-block',
  minWidth: 0,
  maxWidth: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  verticalAlign: 'bottom',
};

export const resolveIteratorLabel = (value: string | number): string => {
  if (typeof value === 'number') return `#${value}`;
  return value.startsWith('#') ? value : `#${value}`;
};

export const resolveDateTimeLabel = (value: Date | string | null): string => {
  const label = formatDate(value, { includeTime: true });
  return label.length > 0 ? label : '-';
};
